// extracted by mini-css-extract-plugin
module.exports = {"employeesListWrapper":"tF5r0","employeesListTitle":"OUL3J","employeesList":"qx1ww","employeesItem":"ZXx+G"};